type RuleCallback<TArgs extends any[]> = (...args: TArgs) => boolean;

export const composeAND = <TArgs extends any[]>(...rules: RuleCallback<TArgs>[]) => {
    return (...args: TArgs) => {
        return rules.every(item => Boolean(item(...args)));
    };
};

export const composeOR = <TArgs extends any[]>(...rules: RuleCallback<TArgs>[]) => {
    return (...args: TArgs) => {
        return rules.some(item => Boolean(item(...args)));
    };
};

export const not = <TArgs extends any[]>(rule: RuleCallback<TArgs>) => {
    return (...args: TArgs) => {
        return !rule(...args);
    };
}